import initDiffsApp from '~/diffs';
import { initMrPage } from '~/pages/projects/merge_requests/page';

initMrPage();
initDiffsApp();
